import { Nullable } from 'legacy/lut/classes/models/utils'
import { FC, useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import { getFormattedFinance } from '../../../../../../../helpers/getFormattedFinance'
import { TRANSLATION_KEYS } from '../../translations'

import styles from './DistributorInfoReadMode.module.scss'

interface IDistributorInfoReadModeProps {
  totalSales: Nullable<number>
  hpDedicatedSales: Nullable<number>
  employersCount: Nullable<number>
}

export const DistributorInfoReadMode: FC<IDistributorInfoReadModeProps> = ({
  totalSales,
  employersCount,
  hpDedicatedSales,
}) => {
  const formattedTotalSalesCount = useMemo(() => {
    if (totalSales === null) {
      return '-'
    }

    return getFormattedFinance(totalSales, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
  }, [totalSales])

  const formattedEmployersCount = useMemo(() => {
    if (employersCount === null) {
      return '-'
    }

    return getFormattedFinance(employersCount, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
  }, [employersCount])

  const formattedHpDedicatedSalesCount = useMemo(() => {
    if (hpDedicatedSales === null) {
      return '-'
    }

    return getFormattedFinance(hpDedicatedSales, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
  }, [hpDedicatedSales])

  return (
    <div className={styles.root}>
      <div className={styles.fieldWrapper}>
        <div className={styles.value}>{formattedTotalSalesCount}</div>
        <div className={styles.label}>
          <Translation text={TRANSLATION_KEYS.totalSalesLabel} />
        </div>
      </div>
      <div className={styles.fieldWrapper}>
        <div className={styles.value}>{formattedHpDedicatedSalesCount}</div>
        <div className={styles.label}>
          <Translation text={TRANSLATION_KEYS.hpDedicatedSalesLabel} />
        </div>
      </div>
      <div className={styles.fieldWrapper}>
        <div className={styles.value}>{formattedEmployersCount}</div>
        <div className={styles.label}>
          <Translation text={TRANSLATION_KEYS.employersCountLabel} />
        </div>
      </div>
    </div>
  )
}
